export default {
  methods: {
    displayCurrency(val) {
      if (!!val) {
        return `$${val.toFixed(2)}`
      } else {
        return '-'
      }
    },
    displayDecimal(val, decimals) {
      if (!!val) {
        return `${Number(val).toFixed(decimals)}`
      } else {
        return '-'
      }
    }
  },
}